export default __webpack_public_path__ + "static/media/man.ab45eb1d.png";